import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isAdmin } from '../../services/auth';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import ToolCard from './components/ToolCard';
import CaseCard from './components/CaseCard';

export default function HomePage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [activeCategory, setActiveCategory] = useState('可盖章');

  useEffect(() => {
    if (user && isAdmin(user)) {
      navigate('/admin');
    }
  }, [user, navigate]);

  const [activeMenu, setActiveMenu] = useState('首页');

  const tools = [
    {
      icon: 'https://readdy.ai/api/search-image?query=Teal%20gradient%20video%20generation%20icon%20with%20play%20button%20and%20film%20strip%20design%20on%20dark%20background%2C%20modern%20minimalist%20style%2C%203D%20effect%2C%20technology%20theme&width=80&height=80&seq=tool1&orientation=squarish',
      title: '视频生成',
      description: 'PPT 生成 AI 视频，生成效果更好的视频内容',
      badge: null,
      menuId: '视频生成',
      path: '/sora2-video'
    },
    {
      icon: 'https://readdy.ai/api/search-image?query=Purple%20gradient%20video%20clone%20icon%20with%20dual%20screen%20design%20on%20dark%20background%2C%20modern%20minimalist%20style%2C%203D%20effect%2C%20technology%20theme&width=80&height=80&seq=tool2&orientation=squarish',
      title: '首尾帧视频',
      description: '上传首尾帧参考图，结合描述词生成过渡视频',
      badge: null,
      menuId: '首尾帧视频',
      path: '/veo31-video'
    },
    {
      icon: 'https://readdy.ai/api/search-image?query=Orange%20gradient%20storyboard%20icon%20with%20grid%20layout%20design%20on%20dark%20background%2C%20modern%20minimalist%20style%2C%203D%20effect%2C%20technology%20theme&width=80&height=80&seq=tool3&orientation=squarish',
      title: '故事板',
      description: '多镜头分镜脚本一键生成视频，支持批量对比与管理',
      badge: null,
      menuId: '故事板',
      path: '/sora2-storyboard'
    },
    {
      icon: 'https://readdy.ai/api/search-image?query=Blue%20gradient%20movie%20camera%20icon%20with%20film%20reel%20design%20on%20dark%20background%2C%20modern%20minimalist%20style%2C%203D%20effect%2C%20technology%20theme&width=80&height=80&seq=tool5&orientation=squarish',
      title: '一键出大片',
      description: '可一键，可一键批量点赞，可以批量点赞',
      badge: null,
      menuId: '一键出大片',
      path: '/one-click-video'
    },
    {
      icon: 'https://readdy.ai/api/search-image?query=Pink%20gradient%20fashion%20model%20icon%20with%20star%20design%20on%20dark%20background%2C%20modern%20minimalist%20style%2C%203D%20effect%2C%20technology%20theme&width=80&height=80&seq=tool6&orientation=squarish',
      title: '虚拟模特库',
      description: '可浏览，可支持，触发对浏览器可以进行，提供记录',
      badge: null,
      menuId: '虚拟模特库',
      path: '/'
    },
    {
      icon: 'https://readdy.ai/api/search-image?query=Pink%20gradient%20AI%20generation%20icon%20with%20layered%20papers%20design%20on%20dark%20background%2C%20modern%20minimalist%20style%2C%203D%20effect%2C%20technology%20theme&width=80&height=80&seq=tool7&orientation=squarish',
      title: '高精度文生图',
      description: '可盖章，可修图，AI、生成文字可修改的矢量图',
      badge: null,
      menuId: 'AI生图',
      path: '/ai-image'
    },
    {
      icon: 'https://readdy.ai/api/search-image?query=Teal%20gradient%20palette%20icon%20with%20color%20swatches%20design%20on%20dark%20background%2C%20modern%20minimalist%20style%2C%203D%20effect%2C%20technology%20theme&width=80&height=80&seq=tool8&orientation=squarish',
      title: '智能风格转换',
      description: '对图片执行AI风格的变化，建筑类文档转化',
      badge: null,
      menuId: '智能风格转换',
      path: '/style-transfer'
    },
    {
      icon: 'https://readdy.ai/api/search-image?query=Teal%20gradient%20AI%20chat%20icon%20with%20speech%20bubble%20design%20on%20dark%20background%2C%20modern%20minimalist%20style%2C%203D%20effect%2C%20technology%20theme&width=80&height=80&seq=tool9&orientation=squarish',
      title: 'AI 对话助手',
      description: '可对 Word 文档进行批改，可以批量批改试卷',
      badge: null,
      menuId: 'AI对话助手',
      path: '/ai-chat'
    }
  ];

  const categories = [
    { id: '可盖章', label: '可盖章' },
    { id: '关心品', label: '关心品' },
    { id: '对不同视频', label: '对不同视频' },
    { id: '视频生成', label: '视频生成' },
    { id: '一键AI人', label: '一键AI人' },
    { id: 'Web3 可视化', label: 'Web3 可视化' }
  ];

  const cases = [
    {
      image: 'https://readdy.ai/api/search-image?query=Person%20crafting%20wooden%20bowl%20in%20warm%20sunlit%20workshop%2C%20artisan%20hands%20working%20on%20traditional%20woodworking%2C%20peaceful%20creative%20atmosphere%2C%20natural%20lighting%2C%20craft%20tools%20visible&width=280&height=360&seq=case1&orientation=portrait',
      category: '一键点赞',
      title: '可浏览，可支持，可以一键批量点赞，可批量点赞，可以批量点赞，可批量点赞',
      date: '2天前发布'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Two%20red%20commercial%20trucks%20parked%20at%20service%20station%20with%20Chinese%20signage%2C%20industrial%20automotive%20scene%2C%20daytime%20outdoor%20setting%2C%20professional%20vehicle%20maintenance&width=280&height=360&seq=case2&orientation=portrait',
      category: '对不同视频',
      title: '三个视频可一键批量对比视频的对比对比对比对比对比对比对比对比对比对比',
      date: '3天前发布'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Beige%20folding%20camping%20chair%20by%20peaceful%20lake%20with%20forest%20background%2C%20outdoor%20relaxation%20scene%2C%20natural%20environment%2C%20serene%20water%20reflection&width=280&height=360&seq=case3&orientation=portrait',
      category: '对不同AI人视频',
      title: '对不同AI人视频可一键批量对比视频的对比对比对比对比对比对比',
      date: '5天前发布'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Luxury%20brown%20leather%20handbags%20collection%20display%2C%20designer%20bags%20with%20metal%20hardware%20details%2C%20premium%20fashion%20accessories%2C%20elegant%20product%20photography&width=280&height=360&seq=case4&orientation=portrait',
      title: '可对比对比对比对比对比对比对比对比对比对比对比对比对比对比对比',
      date: '6天前发布'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20food%20market%20interior%20with%20hanging%20products%20and%20vintage%20signage%2C%20authentic%20local%20marketplace%20atmosphere%2C%20cultural%20shopping%20scene&width=280&height=360&seq=case5&orientation=portrait',
      category: '一键点赞',
      title: '可批量对比对比对比对比对比对比对比对比对比对比对比对比对比对比',
      date: '7天前发布'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20green%20fitted%20dress%20smiling%20at%20camera%2C%20professional%20portrait%20photography%2C%20warm%20indoor%20lighting%2C%20confident%20pose&width=280&height=360&seq=case6&orientation=portrait',
      category: '对不同AI人',
      title: '对不同批量对比对比对比对比对比对比对比对比对比对比对比对比对比',
      date: '8天前发布'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Ornate%20golden%20picture%20frames%20displaying%20year%202025%20and%202026%2C%20luxury%20decorative%20frames%20with%20baroque%20style%20details%2C%20elegant%20wall%20display&width=280&height=360&seq=case7&orientation=portrait',
      category: '翻译器',
      title: '可对比对比对比对比对比对比对比对比对比对比对比对比对比对比对比',
      date: '9天前发布'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Stylish%20woman%20in%20white%20crop%20top%20and%20beige%20pants%20posing%20outdoors%20in%20winter%2C%20fashion%20photography%2C%20snowy%20background%2C%20confident%20modern%20style&width=280&height=360&seq=case8&orientation=portrait',
      category: '对不同AI人',
      title: '可对比对比，生成批量，可对比 可对比，可对比，可对比',
      date: '10天前发布'
    }
  ];

  const filteredTools = activeMenu === '首页' ? tools : tools.filter(tool => tool.menuId === activeMenu);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex">
      <Sidebar activeMenu={activeMenu} onMenuChange={setActiveMenu} />
      
      <div className="flex-1 flex flex-col bg-[#0a0a0a] min-w-0">
        <Navbar />
        
        <main className="flex-1 main-content-padding py-6 sm:py-8 lg:py-12 overflow-y-auto overflow-x-hidden bg-[#0a0a0a]">
          {/* AI Tools Section */}
          <section className="mb-12 sm:mb-20">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8">AI 创作工具</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
              {filteredTools.map((tool, index) => (
                <ToolCard key={index} {...tool} />
              ))}
            </div>
          </section>

          {/* Cases Section */}
          <section>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-6 sm:mb-8">
              <h2 className="text-2xl sm:text-3xl font-bold">客户案例展示</h2>
              <p className="text-gray-400 text-sm">让你的创意成为，盖印可批量对比！！</p>
            </div>

            {/* Category Filter */}
            <div className="flex flex-wrap gap-2 sm:gap-3 mb-6 sm:mb-8">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveCategory(category.id)}
                  className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeCategory === category.id
                      ? 'bg-blue-600 text-white'
                      : 'bg-[#1a1a1a] text-gray-300 hover:bg-[#252525]'
                  }`}
                >
                  {category.label}
                </button>
              ))}
            </div>

            {/* Cases Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
              {cases.map((caseItem, index) => (
                <CaseCard key={index} {...caseItem} />
              ))}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}
